import { Box, Typography, IconButton } from '@mui/material'
import GoogleIcon from '../../components/icon/GoogleIcon'
import { useState } from 'react'
import { SECTION_COLLAPSE_STYLES } from '../details/constants/ClientDashboardConst'

export default function Section({ title, icon, defaultOpen = true, children }) {
  return (
    <Box
      className="section-elevated"
      sx={{
        mb: 2
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          py: 1.5,
          cursor: 'pointer'
        }}
      >
        <Box display="flex" alignItems="center" gap={1}>
          {icon}
          <Typography
            fontWeight={SECTION_COLLAPSE_STYLES.titleWeight}
            color={SECTION_COLLAPSE_STYLES.titleColor}
          >
            {title}
          </Typography>
        </Box>
      </Box>
      <Box px={2} pb={2}>
        {children}
      </Box>
    </Box>
  )
}
